// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 365 ? "9e82d048" : chunkId) + "." + {"365":"d18ff1c972df9b39","637":"df7fb7044ca6ac10","651":"9078e83f25d7ee7c","741":"cd9485d61f910928"}[chunkId] + ".js";
};